import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {ButtonComponent} from '@sms-ir/ui-components';

import {LoadingService} from '@shared/services/loading.service';

@Component({
  selector: 'app-c404',
  standalone: true,
  imports: [RouterLink, ButtonComponent],
  templateUrl: './c404.component.html',
  styleUrls: ['./c404.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class C404Component implements OnInit {
  constructor(
    private loadingService: LoadingService,
  ) {
    this.loadingService.setModalLoadingState(false);
  }

  ngOnInit(): void {
  }
}
